import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import roRO from 'antd/locale/ro_RO';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/ro';
import { useTranslation } from 'react-i18next';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { getTheme } from './theme/antdTheme';
import PrivateRoute from './components/common/PrivateRoute';
import MainLayout from './components/layout/MainLayout';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import DepartmentList from './pages/department/DepartmentList';
import EmployeeList from './pages/employee/EmployeeList';
import CalendarView from './pages/calendar/CalendarView';
import LeaveManagement from './components/leave/LeaveManagement';
import 'antd/dist/reset.css';
import './App.css';

const DefaultRouteRedirect = () => {
  const { getDefaultRoute } = useAuth();
  return <Navigate to={getDefaultRoute()} replace />;
};

const ThemedApp = () => {
  const { isDarkMode } = useTheme();
  const { i18n } = useTranslation();
  const currentTheme = getTheme(isDarkMode);
  dayjs.locale(i18n.language === 'ro' ? 'ro' : 'en');

  return (
    <ConfigProvider theme={currentTheme} locale={i18n.language === 'ro' ? roRO : enUS}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Routes>
                      <Route
                        path="/dashboard"
                        element={
                          <PrivateRoute requiredRoles={['ADMIN', 'HR', 'RECEPTION']}>
                            <Dashboard />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/departments"
                        element={
                          <PrivateRoute requiredRoles={['ADMIN', 'HR', 'RECEPTION']}>
                            <DepartmentList />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/employees"
                        element={
                          <PrivateRoute requiredRoles={['ADMIN', 'HR']}>
                            <EmployeeList />
                          </PrivateRoute>
                        }
                      />
                      <Route path="/calendar" element={<CalendarView />} />
                      <Route path="/leave" element={<LeaveManagement />} />
                      <Route path="/" element={<DefaultRouteRedirect />} />
                    </Routes>
                  </MainLayout>
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  );
}

export default App;
